import axiosInstance from "../util/AxiosInstance/AxiosInstance";

export const getUsers = async () => {
    try {
        const response = await axiosInstance.get('/admin/getUsers');

        if (!response.data.success) {
            // console.log("Error getting users:   ", response.data);
            return { success: false, message: "Error getting users." }
        }

        return { success: true, message: "Successfully retreived users.", users: response.data.users }
    } catch (err) {
        // console.log("Error getting users:   ", err)
        return { success: false, message: "Error getting users."}
    }
}

export const addUser = async ({ email, password}) => {
    try {
        const response = await axiosInstance.post('/admin/addUser', { email, password })

        if (!response.data.success) {
            // console.log("Error adding user")
            return { success: false, message: "Error creating new user"}
        }

        return { success: true, message: "Succesfully created new user" }
    } catch (err) {
        // console.log("Error adding user: ", err);
        return { success: false, message: "Error creating user. "}
    }
}

export const deleteUser = async ({ email }) => {
    try {
        const response = await axiosInstance.delete('/admin/deleteUser', { data: { email } })

        if (!response.data.success) {
            // console.log("Error deleting user");
            return { success: false, message: "Error deleting user." }
        }

        return { success: true, message: "User Deleted." }
    } catch (err) {
        // console.log("Error deleting user:   ", err);
        return { success: false, message: "Error deleting user"}
    }
}

export const createBlogPost = async ({ title, content, category }) => {
    try {
        const response = await axiosInstance.post('/admin/createBlogPost', { title, content, category });

        if (!response.data.success) {
            console.log("Error creating blogpost.");
            return { success: false, message: 'Error creating post' };
        }

        return { success: true, message: 'Blog Post Created' };
    } catch (err) {
        console.log("Error creating blogpost:   ", err)
        return { success: false, message: 'Error creating post' }
    }
}

export const getAllBlogPosts = async () => {
    try {
        const response = await axiosInstance.get('/admin/getAllBlogPosts');

        if (!response.data.success) {
            // console.log("Error fetching all blog posts:", response.data.message);
            return { 
                success: false, 
                message: response.data.message || 'Error fetching all posts' 
            };
        }

        return { 
            success: true, 
            message: response.data.message, 
            posts: response.data.posts 
        };
    } catch (err) {
        // console.log("Error fetching all blog posts:", err);
        return { 
            success: false, 
            message: 'Error fetching all blog posts' 
        };
    }
}

export const getBlogPost = async ({ title }) => {
    try {
        const response = await axiosInstance.get(`/admin/getBlogPost?title=${encodeURIComponent(title)}`);

        if (!response.data.success) {
            // console.log("Error fetching blog post:", response.data.message);
            return { success: false, message: response.data.message || 'Error fetching post' };
        }

        return { 
            success: true, 
            message: response.data.message, 
            post: response.data.post 
        };
    } catch (err) {
        // console.log("Error fetching blog post:", err);
        return { success: false, message: 'Error fetching blog post' };
    }
}

export const updateBlogPost = async ({ oldTitle, newTitle, content }) => {
    try {
        const response = await axiosInstance.put('/admin/updateBlogPost', { 
            oldTitle, 
            newTitle, 
            content 
        });

        if (!response.data.success) {
            // console.log("Error updating blog post:", response.data.message);
            return { 
                success: false, 
                message: response.data.message || 'Error updating post' 
            };
        }

        return { 
            success: true, 
            message: response.data.message || 'Blog post updated successfully',
            post: response.data.post
        };
    } catch (err) {
        // console.log("Error updating blog post:", err);
        return { 
            success: false, 
            message: 'Error updating blog post' 
        };
    }
};